import { Slide, ToastContainer } from "react-toastify";
import { Expand, Heart } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import arrowleft from "../../../assets/icons/left_arrow_black.svg";
import arrowright from "../../../assets/icons/right_arrow_black.svg";
import LoginPromptModal from "../../../components/LoginModal/LoginPromptModal";
import { useBestsellerSlider } from "../hooks/useBestsellerSlider";
import "../../Home/styles/BestsellersSlider.css";
import { getProductPdpUrl } from "../../../utils/url.utils";
import { formatDiscount, formatPrice } from "../../../utils/price.utils";
import { limitChars } from "../../../utils/text.utils";

function BestsellersSlider({ onQuickView }) {
  const navigate = useNavigate();

  const {
    bestsellers,
    isMobile,
    showLoginPrompt,
    setShowLoginPrompt,
    toggleWishlist,
    sliderRef,
    slideIndex,
    transitionEnabled,
    totalProducts,
    cardWidth,
    gap,
    handlePrev,
    handleNext,
  } = useBestsellerSlider({ onQuickView });

  // 🛡 Safety
  if (!totalProducts || totalProducts.length === 0) return null;

  // ✅ LEFT PRODUCT (dynamic)
  const firstProduct = totalProducts[slideIndex] || totalProducts[0];

  // RIGHT SLIDER DATA (no break)
  const sliderProducts =
    totalProducts.slice(slideIndex + 1).length > 0
      ? totalProducts.slice(slideIndex + 1)
      : totalProducts;

  return (
    <>
      <div className="bestseller-container">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          limit={1}
          hideProgressBar
          transition={Slide}
        />

        {isMobile ? (
          <>
            <div className="slider-strip">
              {bestsellers?.map((item) => (
                <div
                  className="bestseller-card"
                  key={item.id}
                  onClick={(e) => {
                    if (e.target.closest(".wishlist-btn_products")) return;

                    window.location.href = getProductPdpUrl(
                      item.action_url,
                      item.sku
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="image-wrapper">
                    <div className="wrp_main">
                      <img
                        className="img_main_asp"
                        src={item?.media_list?.main?.file}
                        alt={item.fullname}
                      />

                      <img
                        className="img_main_asp_hvr"
                        src={item?.media_list?.hover?.file}
                        alt={item.fullname}
                      />
                    </div>

                    {/* Wishlist */}
                    <button
                      className="wishlist-btn_products"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleWishlist(e, item);
                      }}
                    >
                      <Heart
                        color={item.is_wishlisted ? "#FF0000" : "#000"}
                        fill={item.is_wishlisted ? "#FF0000" : "none"}
                        size={20}
                        strokeWidth={2}
                      />
                    </button>
                  </div>

                  <div className="product-info" style={{ paddingBottom: "10px" }}>
                    <span className="title title-height">
                      <Link to={getProductPdpUrl(item.action_url, item.sku)}>
                        {limitChars(item.name, 15)}
                      </Link>
                    </span>

                    <span className="price">
                      {formatPrice(item.selling_price)}
                    </span>

                    {firstProduct?.discount_percent > 0 && (
                      <>
                        &nbsp;
                        <span className="original">
                          <del>{formatPrice(firstProduct.mrp)}</del>
                        </span>
                        &nbsp;
                        <span className="discount">
                          {firstProduct?.discount_percent}% OFF
                        </span>
                      </>
                    )}
                  </div>

                </div>
              ))}
            </div>
          </>
        ) : (

          <div
            className="bestseller-slider"
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: `${gap}px`,
            }}
          >
            {/* ================= LEFT PRODUCT ================= */}
            <div
              className="bestseller-card"
              style={{ flex: "0 0 auto", width: `${cardWidth}px` }}
            >
              <div className="image-wrapper">
                <img
                  className="img_main_asp"
                  src={firstProduct?.media_list?.main?.file}
                  alt={firstProduct.fullname}
                />

                <img
                  className="img_main_asp_hvr"
                  src={firstProduct?.media_list?.hover?.file}
                  alt={firstProduct.fullname}
                />

                <div className="order_view_btn">
                  <button
                    className="quick-view"
                    onClick={(e) => {
                      e.stopPropagation();
                      onQuickView && onQuickView(firstProduct);
                    }}
                  >
                    Quick View <Expand size={15} />
                  </button>
                </div>

                <button
                  className="wishlist-btn_products"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleWishlist(e, firstProduct);
                  }}
                >
                  <Heart
                    color={
                      firstProduct.is_wishlisted ? "#FF0000" : "#000"
                    }
                    fill={
                      firstProduct.is_wishlisted ? "#FF0000" : "none"
                    }
                    size={20}
                  />
                </button>
              </div>

              <div className="product-info">
                <Link
                  to={getProductPdpUrl(
                    firstProduct.action_url,
                    firstProduct.sku
                  )}
                  target="_blank"
                >
                  <span className="title title-height" >
                    {firstProduct.fullname?.slice(0, 11) + "..."}
                  </span>
                </Link>
                <span className="price">
                  {formatPrice(firstProduct.selling_price)}
                </span>

                {firstProduct?.discount_percent > 0 && (
                  <>
                    &nbsp;
                    <span className="original">
                      <del>{formatPrice(firstProduct.mrp)}</del>
                    </span>
                    &nbsp;
                    <span className="discount">
                      {firstProduct?.discount_percent}% OFF
                    </span>
                  </>
                )}
              </div>
            </div>

            {/* ================= STATIC BLACK BOX ================= */}
            <div className="bestseller-fixed-card "
            // style={{
            //   width: "300px",
            //   height: "100%",
            //   minHeight: "350px",
            //   background: "#000",
            //   color: "#fff",
            //   display: "flex",
            //   flexDirection: "column",
            //   justifyContent: "center",
            //   alignItems: "center",
            //   flex: "0 0 auto",
            //   padding: "20px",
            //   textAlign: "center",
            // }}
            >
              <h3> Get the <em>Bestsellers</em> </h3>

              <div className="arrow-controls">
                <button className="btn_arrow left" onClick={handlePrev}>
                  <img src={arrowleft} alt="prev" className="arrow-img" />
                </button>

                <button className="btn_arrow right" onClick={handleNext}>
                  <img src={arrowright} alt="next" className="arrow-img" />
                </button>
              </div>

            </div>

            {/* ================= RIGHT SLIDER ================= */}
            <div
              className="slider-track-wrapper"
              style={{
                overflow: "hidden",
                flex: 1,
                position: "relative",
              }}
            >
              {/* Arrows */}
              {/* <div className="arrow-controls">
                <button onClick={handlePrev}>
                  <img src={arrowleft} alt="prev" />
                </button>

                <button onClick={handleNext}>
                  <img src={arrowright} alt="next" />
                </button>
              </div> */}

              <div
                className="slider-track"
                ref={sliderRef}
                style={{
                  display: "flex",
                  gap: `${gap}px`,
                  transform: `translateX(-${slideIndex * (cardWidth + gap)
                    }px)`,
                  transition: transitionEnabled
                    ? "transform 0.6s ease"
                    : "none",
                  width: `${sliderProducts.length * (cardWidth + gap)
                    }px`,
                }}
              >
                {sliderProducts.map((item, idx) => (
                  <div
                    className="bestseller-card"
                    key={item.id || idx}
                    style={{
                      flex: "0 0 auto",
                      width: `${cardWidth}px`,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        getProductPdpUrl(item.action_url, item.sku),
                        "_blank"
                      )
                    }
                  >
                    <div className="image-wrapper">
                      <img
                        className="img_main_asp"
                        src={item?.media_list?.main?.file}
                        alt={item.fullname}
                      />

                      <img
                        className="img_main_asp_hvr"
                        src={item?.media_list?.hover?.file}
                        alt={item.fullname}
                      />

                      <div className="order_view_btn">
                        <button
                          className="quick-view"
                          onClick={(e) => {
                            e.stopPropagation();
                            onQuickView && onQuickView(item);
                          }}
                        >
                          Quick View <Expand size={15} />
                        </button>
                      </div>

                      <button
                        className="wishlist-btn_products"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          toggleWishlist(e, item);
                        }}
                      >
                        <Heart
                          color={
                            item.is_wishlisted ? "#FF0000" : "#000"
                          }
                          fill={
                            item.is_wishlisted ? "#FF0000" : "none"
                          }
                          size={20}
                        />
                      </button>
                    </div>

                    <div className="product-info">
                      <Link
                        to={getProductPdpUrl(
                          item.action_url,
                          item.sku
                        )}
                        target="_blank"
                      >
                        <span className="title title-height">
                          {limitChars(item.name, 16)}
                        </span>
                      </Link>

                      <span className="price">
                        {formatPrice(item.selling_price)}
                      </span>

                      {item.discount_percent > 0 && (
                        <>
                          &nbsp;
                          <span className="original">
                            <del>{formatPrice(item.mrp)}</del>
                          </span>
                          &nbsp;
                          <span className="discount">
                            {formatDiscount(item?.discount_percent)}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>


        )}

        {showLoginPrompt && (
          <LoginPromptModal
            onClose={() => setShowLoginPrompt(false)}
          />
        )}
      </div>
    </>
  );
}
export default BestsellersSlider;